<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct para-style-override-3" id="toc_marker-5"><a href="#/There_Was_a_Crooked_Man2#Contents-A">Acknowledgments</a></p>
<p class="fp">Our heartfelt thanks to all who helped make <span class="Italic">There Was a Crooked Man</span> possible. To the best papa ever, Harold Larsen. To our sweet mama, Arlene Larsen. If we didn’t know you were laughing on the other side, we couldn’t write comedy. To our number one sissy, Lynn Lee Higbee. And our dear friends, Alan Mitchell and Amanda Boblet. </p>
<p class="body">A big shout out for the amazing cast at Poisoned Pen Press. And mostly for our extraordinary, long-suffering editor, Barbara Peters. She’s no less than magical. </p>
<p class="Body-Center para-style-override-3"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// There_Was_a_Crooked_Man-4.vue?607266b2